import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import Button from '../ui/Button';
import { AShapeBg } from '../ui/DecorativeElements';

const { FiMapPin, FiPhone, FiMail } = FiIcons;

const Contact = () => {
  return (
    <section className="py-24 relative bg-navy-gradient text-white overflow-hidden">
      <AShapeBg className="text-white w-[800px] h-[800px] -left-64 -top-64 opacity-5" />
      
      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-alpha-green font-semibold tracking-wider uppercase mb-2 text-sm">Get In Touch</h2>
            <h3 className="text-3xl md:text-4xl font-bold mb-6">Ready to elevate your workforce?</h3>
            <p className="text-alpha-grayLight/80 mb-10 text-lg">
              Contact our consultants today to discuss tailored training solutions for your organization or to register for upcoming courses.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMapPin} className="text-alpha-green text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Head Office</h4>
                  <p className="text-alpha-grayLight/70">123 Corporate Way, #04-01<br/>Enterprise Hub, Singapore 123456</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiPhone} className="text-alpha-green text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Phone</h4>
                  <p className="text-alpha-grayLight/70">+65 6123 4567<br/>Mon-Fri, 9am - 6pm</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <SafeIcon icon={FiMail} className="text-alpha-green text-xl" />
                </div>
                <div>
                  <h4 className="font-bold text-lg mb-1">Email</h4>
                  <p className="text-alpha-grayLight/70">enquiries@alphaconsultancy.sg</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-white rounded-2xl p-8 shadow-2xl text-alpha-navy"
          >
            <h4 className="text-2xl font-bold mb-6">Send us a message</h4>
            <form className="space-y-4" onSubmit={(e) => e.preventDefault()}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-alpha-grayDark">First Name</label>
                  <input type="text" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-alpha-green transition-shadow bg-gray-50" placeholder="John" />
                </div>
                <div className="space-y-2">
                  <label className="text-sm font-medium text-alpha-grayDark">Last Name</label>
                  <input type="text" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-alpha-green transition-shadow bg-gray-50" placeholder="Doe" />
                </div>
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-alpha-grayDark">Email Address</label>
                <input type="email" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-alpha-green transition-shadow bg-gray-50" placeholder="john@company.com" />
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-alpha-grayDark">Inquiry Type</label>
                <select className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-alpha-green transition-shadow bg-gray-50 text-alpha-grayDark">
                  <option>Corporate Training</option>
                  <option>Safety Courses</option>
                  <option>Domestic Worker Orientation</option>
                  <option>Other</option>
                </select>
              </div>
              <div className="space-y-2">
                <label className="text-sm font-medium text-alpha-grayDark">Message</label>
                <textarea rows="4" className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-alpha-green transition-shadow bg-gray-50" placeholder="How can we help you?"></textarea>
              </div>
              <Button variant="primary" className="w-full py-4 text-lg mt-2">
                Submit Inquiry
              </Button>
            </form>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Contact;